import React from "react";

const IconButton = ({ icon, href }) => {
    return (
        <a target="_blank" href={href} className="success btns btn-inside about-icon"><i className={icon || "flaticon-questions-circular-button"} /></a>
    )
}

export default IconButton